import React from 'react';
import { InputLabel, MenuItem, Select, SelectChangeEvent, SelectProps } from '@mui/material';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useController, useId, useCallback } from 'hooks';
import { SelectorValue } from 'types/types';

import styles from './styles.module.sass';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  name: FieldPath<T>;
  label: string;
  values: SelectorValue[];
} & SelectProps;

export const Selector = <T extends FieldValues>({ name, control, values, label, ...props }: Properties<T>) => {
  const { field } = useController({ name, control });
  const { value, onChange } = field;
  const id = useId();

  const activeValue = values.find(({ id }) => id === value);

  const onChangeHandler = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      const newValue = values.find(({ label }) => label === event.target.value);
      onChange(newValue?.id);
    },
    [onChange, values],
  );

  return (
    <div className={styles.container}>
      <InputLabel id={id}>{label}</InputLabel>
      <Select
        className={styles.select}
        {...props}
        labelId={id}
        value={activeValue?.label ?? ''}
        onChange={onChangeHandler}
      >
        {values.map(({ label, id }) => (
          <MenuItem key={id} value={label}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
